module.exports = __webpack_public_path__ + "img/ticket.c6066f6f.png";